export enum DashboardUserTables {
  RESOURCE_PLANNING = 'Resource Planning',
  UNDERBOOKING = 'Underbooking',
  OVERBOOKING = 'Overbooking',
}

export enum DashboardFieldsColor {
  REVENUES = '#228086',
  COSTS = '#d81212',
  MARGINS = '#1b7112',
  RATE = '#a600b0',
  FTE = '#ce9e32',
  INVOICES = '#4e73df',
}

export enum FilterPeriodEnum {
  CURRENT_YEAR = 'CURRENT_YEAR',
  TOTAL = 'TOTAL',
  PREC_YEAR = 'PREC_YEAR',
}

export enum FilterPeriodLabelsEnum {
  CURRENT_YEAR = 'Current Year',
  TOTAL = 'All years',
  PREC_YEAR = 'Previous Year',
}
